import axios from './axiosInstances/axiosInstance';

export const getGiftCardBalance = (basketId, billingSchemeId, body, config) => {
  return axios.post(`/baskets/${basketId}/billingschemes/${billingSchemeId}/retrievebalance`, body, config);
};

export const reduceGiftCardBalance = (basketId, billingSchemeId, body, config) => {
  return axios.delete(`/baskets/${basketId}/billingschemes/${billingSchemeId}/retrievebalance`, body, config);
};
